import { useState, useEffect, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import { FaBeer } from "react-icons/fa";
import { RiArrowDownDoubleLine } from "react-icons/ri";

const MainMenu = () => {
    const [show, setShow] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const menuRef = useRef(null);

    const displayNestedMenu = (id) => {
        setShow((prevState) => ({
            ...prevState,
            [id]: !prevState[id], // Toggle visibility for specific id
        }));
    };

    const toggleMenu = (menu) => {
        setOpenMenu((prev) => (prev === menu ? null : menu));
    };

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                setOpenMenu(null);
            }
        };
        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleArrowNavigation = (e) => {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
            e.stopPropagation();

            // 🚨 THIS LINE FIXES SCROLL COMPLETELY
            e.nativeEvent.stopImmediatePropagation?.();

            const currentItem = e.currentTarget.closest(".sub-menu-item");
            if (!currentItem) return;

            const menu = currentItem.parentElement;

            const items = Array.from(menu.querySelectorAll("a.sub-menu-link"));

            const currentIndex = items.indexOf(e.currentTarget);

            let nextIndex =
                e.key === "ArrowDown"
                    ? (currentIndex + 1) % items.length
                    : (currentIndex - 1 + items.length) % items.length;

            items[nextIndex]?.focus();
        }
    };

    return (
        <nav ref={menuRef} className="main-menu d-none d-lg-block">
            <ul className="d-flex">
                {/* <li>
                    <NavLink exact to="/">
                        Home
                    </NavLink>
                </li> */}
                <li>
                    {/* <NavLink to={"#"}>About</NavLink> */}

                    <Link
                        to={"#"}
                        onClick={(e) => {
                            e.preventDefault();
                            toggleMenu("about");
                        }}
                        aria-expanded={openMenu === "about"}
                        aria-haspopup="true"
                    >
                        About
                    </Link>
                    {openMenu === "about" && (
                        <ul className="sub-menu">
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={process.env.PUBLIC_URL + "/about-us"}
                                    onKeyDown={handleArrowNavigation}
                                    tabIndex="0"
                                >
                                    Our Story
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/board-of-directors"
                                    }
                                    onKeyDown={handleArrowNavigation}
                                >
                                    Board Of Directors
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={process.env.PUBLIC_URL + "/partners"}
                                    onKeyDown={handleArrowNavigation}
                                >
                                    Our Partners
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/leadership-team"
                                    }
                                    onKeyDown={handleArrowNavigation}
                                >
                                    Leadership Team
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/awards-recognitions/"
                                    }
                                    onKeyDown={handleArrowNavigation}
                                >
                                    Awards & Recognitions
                                </NavLink>
                            </li>
                        </ul>
                    )}
                </li>
                <li>
                    {/* <NavLink to={"#"}>Investor Relations</NavLink> */}
                    <Link
                        to={"#"}
                        onClick={(e) => {
                            e.preventDefault();
                            toggleMenu("investor");
                        }}
                        aria-expanded={openMenu === "investor"}
                        aria-haspopup="true"
                    >
                        Investor Relations
                    </Link>

                    {openMenu === "investor" && (
                        <ul className="sub-menu">
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/annual-report"
                                    }
                                >
                                    Annual Report
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/annual-return"
                                    }
                                >
                                    Annual Return
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/financial-results"
                                    }
                                >
                                    Financial Results
                                </NavLink>
                            </li>

                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/stock-exchange-intimation"
                                    }
                                >
                                    Stock Exchange Intimation
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/rbi-disclosures"
                                    }
                                >
                                    RBI Disclosures
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/company-policies"
                                    }
                                >
                                    Company Policies
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/consumer-education"
                                    }
                                >
                                    Consumer Education
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                <Link
                                    className="sub-menu-link"
                                    rel="noopener noreferrer"
                                    to={process.env.PUBLIC_URL + "/neoinsights"}
                                >
                                    NeoInsights
                                </Link>
                            </li>
                            <li className="sub-menu-item">
                                <Link
                                    className="sub-menu-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/pdf/extra/COMPOSITION-OF-BOARD-COMMITTEES.pdf"
                                    }
                                >
                                    Composition of Board Committees
                                </Link>
                            </li>
                            {/* <li className="sub-menu-item">
                                <Link
                                    className="sub-menu-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/pdf/extra/Nodal-Officer-Unclaimed-interest.pdf"
                                    }
                                >
                                    Investor Grievances
                                </Link>
                            </li> */}
                            <li className="sub-menu-item ">
                                <button
                                    id="Investor"
                                    className="sub-menu-btn"
                                    aria-expanded={
                                        show["Investor"] ? true : false
                                    }
                                    aria-controls="digital-lending-apps-menu"
                                    onClick={(event) => {
                                        displayNestedMenu("Investor");
                                    }}
                                >
                                    <NavLink className="sub-menu-link" to={"#"}>
                                        Investor
                                    </NavLink>
                                    <RiArrowDownDoubleLine
                                        size={20}
                                        strokeOpacity={4}
                                        className="align-self-center mx-4"
                                        aria-hidden="true"
                                    />
                                </button>
                                {show["Investor"] && (
                                    <ul className="nested-menu">
                                        <li className="sub-menu-item">
                                            <NavLink
                                                className="sub-menu-link"
                                                target="_blank"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    "/pdf/extra/Nodal-Officer-Unclaimed-interest.pdf"
                                                }
                                            >
                                                Investor Grievance
                                            </NavLink>
                                        </li>
                                        <li className="sub-menu-item">
                                            <NavLink
                                                className="sub-menu-link"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    "/details-of-unclaimed-dividend"
                                                }
                                            >
                                                Details of Unclaimed
                                                Dividend/Interest/Redemption
                                                Amounts
                                            </NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>
                        </ul>
                    )}
                </li>

                <li>
                    <NavLink to={process.env.PUBLIC_URL + "/products"}>
                        Products
                    </NavLink>
                    {/* <ul className="sub-menu">
                        <li className="sub-menu-item">
                            <button
                                id="Retail Finance"
                                className="sub-menu-btn"
                                onClick={(event) => {
                                    displayNestedMenu("Retail Finance");
                                }}
                            >
                                <NavLink className="sub-menu-link" to={"#"}>
                                    Retail Finance
                                </NavLink>
                                <RiArrowDownDoubleLine
                                    size={20}
                                    strokeOpacity={4}
                                    className="align-self-center mx-4 border border-0"
                                />
                            </button>
                            {show["Retail Finance"] && (
                                <ul className="nested-menu">
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/neocash/",
                                            }}
                                        >
                                            NeoCash
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/neocash-express/",
                                            }}
                                        >
                                            NeoCash Express
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/neocash-insta/",
                                            }}
                                        >
                                            NeoCash Insta
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/neocash-plus/",
                                            }}
                                        >
                                            Neocash Plus
                                        </NavLink>
                                    </li>
                                </ul>
                            )}
                        </li>
                        <li className="sub-menu-item ">
                            <button
                                id="Supply Chain Finance"
                                className="sub-menu-btn"
                                onClick={(event) => {
                                    displayNestedMenu("Supply Chain Finance");
                                }}
                            >
                                <NavLink className="sub-menu-link" to="#">
                                    Supply Chain Finance
                                </NavLink>
                                <RiArrowDownDoubleLine
                                    size={20}
                                    strokeOpacity={4}
                                    className="align-self-center mx-4"
                                />
                            </button>
                            {show["Supply Chain Finance"] && (
                                <ul className="nested-menu">
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/vendor-finance/",
                                            }}
                                        >
                                            Vendor Finance
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/accelerator/",
                                            }}
                                        >
                                            Accelerator
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/purchase-finance/",
                                            }}
                                        >
                                            Purchase Finance
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={{
                                                pathname:
                                                    "https://ng.neogrowth.in/productspost/supply-chain-plus/",
                                            }}
                                        >
                                            Supply Chain Plus
                                        </NavLink>
                                    </li>
                                </ul>
                            )}
                        </li>
                    </ul> */}
                </li>
                <li>
                    <Link
                        to={"#"}
                        onClick={(e) => {
                            e.preventDefault();
                            toggleMenu("impact");
                        }}
                        aria-expanded={openMenu === "impact"}
                        aria-haspopup="true"
                    >
                        Impact
                    </Link>
                    {openMenu === "impact" && (
                        <ul className="sub-menu">
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={process.env.PUBLIC_URL + "/impact"}
                                >
                                    Impact Report
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                {/* <NavLink
                                className="sub-menu-link"
                                to={process.env.PUBLIC_URL + "/"}
                            >
                                Client Stories
                            </NavLink> */}
                                <Link
                                    className="sub-menu-link"
                                    rel="noopener noreferrer"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/clientstories"
                                    }
                                >
                                    Client Stories
                                </Link>
                            </li>
                            <li className="sub-menu-item">
                                {/* <NavLink
                                className="sub-menu-link"
                                to={process.env.PUBLIC_URL + "/"}
                            >
                                Client Stories
                            </NavLink> */}
                                <Link
                                    className="sub-menu-link"
                                    rel="noopener noreferrer"
                                    to={process.env.PUBLIC_URL + "/csr"}
                                >
                                    CSR
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li>
                    <Link
                        to={"#"}
                        onClick={(e) => {
                            e.preventDefault();
                            toggleMenu("services");
                        }}
                        aria-expanded={openMenu === "services"}
                        aria-haspopup="true"
                    >
                        Customer Services
                    </Link>
                    {openMenu === "services" && (
                        <ul className="sub-menu">
                            <li className="sub-menu-item">
                                <Link
                                    className="sub-menu-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={{
                                        pathname:
                                            "https://elogin.neogrowth.in/login?service=https%3A%2F%2Fmy.neogrowth.in%2F",
                                    }}
                                >
                                    Login
                                </Link>
                            </li>
                            <li className="sub-menu-item">
                                <Link
                                    className="sub-menu-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={{
                                        pathname:
                                            "https://payments.neogrowth.in/",
                                    }}
                                >
                                    Pay now
                                </Link>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={process.env.PUBLIC_URL + "/faq"}
                                >
                                    FAQ
                                </NavLink>
                            </li>
                            <li className="sub-menu-item">
                                {/* <NavLink
                                className="sub-menu-link"
                                to={process.env.PUBLIC_URL + "/"}
                            >
                                Customer Support
                            </NavLink> */}
                                <Link
                                    className="sub-menu-link"
                                    rel="noopener noreferrer"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/customer-services"
                                    }
                                    aria-current={
                                        window.location.pathname ==
                                        "/customer-services"
                                            ? "page"
                                            : undefined
                                    }
                                >
                                    Support
                                </Link>
                            </li>
                            <li className="sub-menu-item">
                                <NavLink
                                    className="sub-menu-link"
                                    to={
                                        process.env.PUBLIC_URL +
                                        "/service-providers"
                                    }
                                >
                                    Service Providers
                                </NavLink>
                            </li>

                            <li className="sub-menu-item ">
                                <button
                                    id="Loan Documents"
                                    className="sub-menu-btn"
                                    aria-expanded={
                                        show["Loan Documents"] ? true : false
                                    }
                                    onClick={(event) => {
                                        displayNestedMenu("Loan Documents");
                                    }}
                                    aria-controls="loan-documents-menu"
                                >
                                    <NavLink className="sub-menu-link" to={"#"}>
                                        Loan Documents
                                    </NavLink>
                                    <RiArrowDownDoubleLine
                                        size={20}
                                        strokeOpacity={4}
                                        className="align-self-center mx-4"
                                        aria-hidden="true"
                                    />
                                </button>
                                {show["Loan Documents"] && (
                                    <ul className="nested-menu">
                                        <li className="sub-menu-item">
                                            <NavLink
                                                className="sub-menu-link"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    "/loan-agreements-with-collateral"
                                                }
                                            >
                                                Loan Agreements (With
                                                Collateral)
                                            </NavLink>
                                        </li>
                                        <li className="sub-menu-item">
                                            <NavLink
                                                className="sub-menu-link"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    "/loan-agreements-without-collateral"
                                                }
                                            >
                                                Loan Agreements (Without
                                                Collateral)
                                            </NavLink>
                                        </li>
                                        <li className="sub-menu-item">
                                            <NavLink
                                                className="sub-menu-link"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    "/Sanction-Letters-with-collateral"
                                                }
                                            >
                                                Sanction Letters (With
                                                Collateral)
                                            </NavLink>
                                        </li>
                                        <li className="sub-menu-item">
                                            <NavLink
                                                className="sub-menu-link"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    "/Sanction-Letters-without-collateral"
                                                }
                                            >
                                                Sanction Letters (Without
                                                Collateral)
                                            </NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>

                            <li className="sub-menu-item ">
                                <button
                                    id="Digital Lending Apps"
                                    className="sub-menu-btn"
                                    aria-expanded={
                                        show["Digital Lending Apps"]
                                            ? true
                                            : false
                                    }
                                    aria-controls="digital-lending-apps-menu"
                                    onClick={(event) => {
                                        displayNestedMenu(
                                            "Digital Lending Apps"
                                        );
                                    }}
                                >
                                    <NavLink className="sub-menu-link" to={"#"}>
                                        Digital Lending Apps
                                    </NavLink>
                                    <RiArrowDownDoubleLine
                                        size={20}
                                        strokeOpacity={4}
                                        className="align-self-center mx-4"
                                        aria-hidden="true"
                                    />
                                </button>
                                {show["Digital Lending Apps"] && (
                                    <ul className="nested-menu">
                                        <li className="sub-menu-item">
                                            <NavLink
                                                className="sub-menu-link"
                                                to={
                                                    process.env.PUBLIC_URL +
                                                    "/downloadneogrowthapp"
                                                }
                                            >
                                                NeoGrowth App
                                            </NavLink>
                                        </li>
                                        <li className="sub-menu-item">
                                            <Link
                                                className="sub-menu-link"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                to={{
                                                    pathname:
                                                        "https://instaas2.neogrowth.in/",
                                                }}
                                            >
                                                Neocash Insta
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>
                        </ul>
                    )}
                </li>

                {/* <li>
                    <NavLink to={process.env.PUBLIC_URL + "#"}>More</NavLink>
                    <ul className="sub-menu">
                        <li className="sub-menu-item">
                            <NavLink
                                className="sub-menu-link"
                                to={process.env.PUBLIC_URL + "/loan"}
                            >
                                Loan
                            </NavLink>
                        </li>
                        <li className="sub-menu-item">
                            <NavLink
                                className="sub-menu-link"
                                to={process.env.PUBLIC_URL + "/help"}
                            >
                                Help
                            </NavLink>
                        </li>
                        <li className="sub-menu-item">
                            <NavLink
                                className="sub-menu-link"
                                to={
                                    process.env.PUBLIC_URL + "/request-callback"
                                }
                            >
                                Request Callback
                            </NavLink>
                        </li>
                        <li className="sub-menu-item">
                            <Link
                                className="sub-menu-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                to={{
                                    pathname: "https://payments.neogrowth.in/",
                                }}
                            >
                                Pay Now
                            </Link>
                        </li>
                        <li className="sub-menu-item">
                            <Link
                                className="sub-menu-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                to={{
                                    pathname: "https://my.neogrowth.in/",
                                }}
                            >
                                Login
                            </Link>
                        </li>
                        <li className="sub-menu-item">
                            <NavLink
                                className="sub-menu-link"
                                to={
                                    process.env.PUBLIC_URL +
                                    "/downloadneogrowthapp"
                                }
                            >
                                Download NeoGrowth App
                            </NavLink>
                        </li>

                        <li className="sub-menu-item ">
                            <button
                                id="Careers"
                                className="sub-menu-btn"
                                onClick={(event) => {
                                    displayNestedMenu("Careers");
                                }}
                            >
                                <NavLink className="sub-menu-link" to={"#"}>
                                    Careers
                                </NavLink>
                                <RiArrowDownDoubleLine
                                    size={20}
                                    strokeOpacity={4}
                                    className="align-self-center mx-4"
                                />
                            </button>
                            {show["Careers"] && (
                                <ul className="nested-menu">
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            to={process.env.PUBLIC_URL + "#"}
                                        >
                                            Life at NeoGrowth
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            to={process.env.PUBLIC_URL + "#"}
                                        >
                                            Join us
                                        </NavLink>
                                    </li>
                                    <li className="sub-menu-item">
                                        <NavLink
                                            className="sub-menu-link"
                                            to={process.env.PUBLIC_URL + "#"}
                                        >
                                            Second Career for Women
                                        </NavLink>
                                    </li>
                                </ul>
                            )}
                        </li>
                    </ul>
                </li> */}
            </ul>
        </nav>
    );
};

export default MainMenu;
